var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-4"},[_c('checkbox',{attrs:{"is-preselected":_vm.isPreselected,"data-test":"terms-and-conditions"},on:{"checkbox:changed":_vm.handleCheckboxChange}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }